"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShoppingContextProvider = void 0;
var _shoppingSessionContext = require("./shoppingSessionContext");
var _useEvents = require("./useEvents");
var _jsxRuntime = require("react/jsx-runtime");
const ShoppingContextProvider = ({
  eventNames,
  children,
  parentComponentName
}) => {
  const contextValue = (0, _useEvents.useEvents)(eventNames, parentComponentName);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_shoppingSessionContext.shoppingSessionContext.Provider, {
    value: contextValue,
    children: children
  });
};
exports.ShoppingContextProvider = ShoppingContextProvider;
